import {userTypes} from "../types/userTypes";

const initState = {
    authUser: null,
    authUserIsLoading: true,
    authToggleFormStatus: false,
    userUniqueId: -1,
    authSuccess: false,

};
const userReducer = (state = initState, action) => {
    switch (action.type) {
        case userTypes.GET_PROFILE:
            state = {
                ...state,
                authUser: action.payload,
                authUserIsLoading: false,
            };
            break;

        case userTypes.LOGOUT:
            state = {
                ...state,
                authUser: action.payload,
                authUserIsLoading: true,
            };
            break;
        case userTypes.AUTH_TOGGLE_POP_UP_STATUS:
            state = {
                ...state,
                authToggleFormStatus: action.payload,
            };
            break;
        case userTypes.SET_USER_UNIQUE_ID:
            state = {
                ...state,
                userUniqueId: action.payload,
            };
            break;
        case userTypes.SUCCEED_AUTH :
            state = {
                ...state,
                authSuccess: action.payload,
            };
            break;
        default:
        // do nothing
    }
    return state;
};


export default userReducer;